import { BaseModel } from '@kinet-open-network/client/shared/data-access/model';
import {
  AbilitySubjectType,
  IAttachment,
} from '@kinet-open-network/shared/data-access/model';

export class Attachment
  extends BaseModel<Attachment, 'Attachment'>
  implements IAttachment
{
  static override readonly modelName: AbilitySubjectType = 'Attachment';
  name!: string | null;
  mimeType!: string;
  data!: string | null;

  get dataUrl(): string | null {
    if (!this.data || !this.mimeType) {
      return null;
    }

    if (this.data.startsWith('data:')) {
      return this.data;
    }

    return `data:${this.mimeType};base64,${this.data}`;
  }
}
